import { detectView } from './../common/ScreenWidth/ScreenWidth';
import {capitalizeMerchantName} from './../../constants/merchantData';

const s = window.s;

//login-pageload..
export const OnLoginPageLoad = (merchant) => {
    const merchantName = capitalizeMerchantName(merchant)
    s.pageName = `${merchantName}Pull/Login`;
    s.prop32 = "View Port:" + detectView();
    s.prop41 = `${merchantName} Pull:Login Page`;
    s.t();
    clearTags();
};

//login(Call to Action)..
export const OnLoginSubmit = (merchant) => {
    const merchantName = capitalizeMerchantName(merchant)
    s.linkTrackVars = s.linkTrackVars + ',prop1,prop32';
    s.prop1 = `${merchantName} Pull:Login Page:Button:Log In`;
    s.prop32 = 'View Port:' + detectView();
    s.tl(this, 'o', s.prop1);
    clearTags();
}

//Forgot User ID or Password (Call to Action)..
export const ForgotUserPassword = (merchant) => {
    const merchantName = capitalizeMerchantName(merchant)
    s.linkTrackVars = s.linkTrackVars + ',prop1,prop32';
    s.prop1 = `${merchantName} Pull:Login Page:Link:Forgot User ID or Password`;
    s.prop32 = 'View Port:' + detectView();
    s.tl(this, 'o', s.prop1);
    clearTags();
}

//Log in Server Error event
export const OnLoginErrorEvent = (errMsg, merchant) => {
    const merchantName = capitalizeMerchantName(merchant)
    s.prop41 = `${merchantName} Pull:Login Page:Error`;
    s.pageName = `/${merchantName}Pull/Login/Error`;
    s.prop10 = errMsg;
    s.list1 = 'ERROR:' + errMsg;
    s.prop32 = 'View Port:' + detectView();
    s.t();
    clearTags();
}


//Log in Client Error event
export const OnLoginClientErrorEvent = (errMsg, merchant) => {
    const merchantName = capitalizeMerchantName(merchant)
    s.linkTrackVars=s.linkTrackVars+',prop1,prop10,list1,prop41,prop32';
    s.prop1=`${merchantName} Pull:Login Page:Button:Log In`;
    s.prop41 = `${merchantName} Pull:Login Page:Error`;
    s.prop10 = errMsg;
    s.list1 = 'ERROR:' + errMsg;
    s.prop32 = 'View Port:' + detectView();
    s.tl(this,'o',s.prop1);
    clearTags();
}
//Already Linked - pageload..
export const OnAlreadyLinkedPageLoad = (merchant) => {
    const merchantName = capitalizeMerchantName(merchant)
    s.pageName = `/${merchantName}Pull/AlreadyLinked`;
    s.prop32 = 'View Port:' + detectView();
    s.prop41 = `${merchantName} Pull:Already Linked`;
    s.t();
    clearTags();
}

//Already Linked - Set as Preferred Button..
export const OnSetAsPreferred = (merchant) => {
    const merchantName = capitalizeMerchantName(merchant)
    s.linkTrackVars = s.linkTrackVars + ',prop1,prop32';
    s.prop1 = `${merchantName} Pull:Already Linked:Button:Set as Preferred`;
    s.prop32 = 'View Port:' + detectView();
    s.tl(this, 'o', s.prop1);
    clearTags();
}

//Already Linked - Not Now Link..
export const OnNotNow = (merchant) => {
    const merchantName = capitalizeMerchantName(merchant)
    s.linkTrackVars = s.linkTrackVars + ',prop1,prop32';
    s.prop1 = `${merchantName} Pull:Already Linked:Link:Not Now`;
    s.prop32 = 'View Port:' + detectView();
    s.tl(this, 'o', s.prop1);
    clearTags();
}

//ProvisionLimit- Page Load..
export const OnProvisionLimitLoad = (merchant) => {
    const merchantName = capitalizeMerchantName(merchant)
    s.pageName = `/${merchantName}Pull/MaxProvisionLimitError`;
    s.prop32 = 'View Port:' + detectView();
    s.prop41 = `${merchantName} Pull:Max Provision Limit Error`;
    s.t();
    clearTags();
}

//ProvisionLimit - Cancel Link..
export const OnProvisionLimitCancel = (merchant) => {
    const merchantName = capitalizeMerchantName(merchant)
    s.linkTrackVars = s.linkTrackVars + ',prop1,prop32';
    s.prop1 = `${merchantName} Pull:Max Provision Limit Error:Link:Cancel`;
    s.prop32 = 'View Port:' + detectView();
    s.tl(this, 'o', s.prop1);
    clearTags();
}

//Unable to Link - Page Load..
export const OnTechDiffPageLoad = (merchant) => {
    const merchantName = capitalizeMerchantName(merchant)
    s.pageName = `/${merchantName}Pull/UnableToLink`;
    s.prop32 = 'View Port:' + detectView();
    s.prop41 = `${merchantName} Pull:Unable to Link`;
    s.t();
    clearTags();
}

//Unable to Link - Cancel Link..
export const OnTechDiffCancel = (merchant) => {
    const merchantName = capitalizeMerchantName(merchant)
    s.linkTrackVars = s.linkTrackVars + ',prop1,prop32';
    s.prop1 = `${merchantName} Pull:Unable to Link:Link:Cancel`;
    s.prop32 = 'View Port:' + detectView();
    s.tl(this, 'o', s.prop1);
    clearTags();
}

//Card Not Eligible - Page Load..
export const OnNotEligiblePageLoad = (merchant) => {
    const merchantName = capitalizeMerchantName(merchant)
    s.pageName = `/${merchantName}Pull/CardNotEligible`;
    s.prop32 = 'View Port:' + detectView();
    s.prop41 = `${merchantName} Pull:Card Not Eligible`;
    s.t();
    clearTags();
}

//Card Not Eligible - Cancel Link..
export const NotEligibleCancel = (merchant) => {
    const merchantName = capitalizeMerchantName(merchant)
    s.linkTrackVars = s.linkTrackVars + ',prop1,prop32';
    s.prop1 = `${merchantName} Pull:Card Not Eligible:Link:Cancel`;
    s.prop32 = 'View Port:' + detectView();
    s.tl(this, 'o', s.prop1);
    clearTags();
}

//Discover Consent (Single Card) - pageload..
export const OnSingleCardPageLoad = (merchant) => {
    const merchantName = capitalizeMerchantName(merchant)
    s.pageName = `/${merchantName}Pull/DiscoverConsent`;
    s.prop32 = 'View Port:' + detectView();
    s.prop41 = `${merchantName} Pull:Discover Consent:Single Card`;
    s.prop5 = 'Number of Cards=1';
    s.t();
    clearTags();
}

//Discover Consent (Single Card) - Cancel Link..
export const OnSingleCardCancel = (merchant) => {
    const merchantName = capitalizeMerchantName(merchant)
    s.linkTrackVars = s.linkTrackVars + ',prop1,prop32';
    s.prop1 = `${merchantName} Pull:Discover Consent:Single Card:Link:Cancel`;
    s.prop32 = 'View Port:' + detectView();
    s.tl(this, 'o', s.prop1);
    clearTags();
}

//Discover Consent (Single Card) - Link Now Button..
export const OnSingleCardLinkNow = (merchant) => {
    const merchantName = capitalizeMerchantName(merchant)
    s.linkTrackVars = s.linkTrackVars + ',prop1,prop32,prop41';
    s.prop1 = `${merchantName} Pull:Discover Consent:Single Card:Button:Link Now`;
    s.prop32 = 'View Port:' + detectView();
    s.prop41 = `${merchantName} Pull:Discover Consent:Link Now:Number of Cards=1`;
    s.tl(this, 'o', s.prop1);
    clearTags();
}

//Discover Consent (Multi Card) - pageload..
export const OnMultiCardPageLoad = (numofcards, merchant) => {
    const merchantName = capitalizeMerchantName(merchant)
    s.pageName = `/${merchantName}Pull/DiscoverConsent`;
    s.prop32 = 'View Port:' + detectView();
    s.prop41 = `${merchantName} Pull:Discover Consent:Multiple Cards`;
    s.prop5 = 'Number of Cards=' + numofcards;
    s.t();
    clearTags();
}

//Discover Consent (Multi Card) - Link Now Button..
export const OnMultiCardLinkNow = (numofCardsSelect, merchant) => {
    const merchantName = capitalizeMerchantName(merchant)
    s.linkTrackVars = s.linkTrackVars + ',prop1,prop32,prop41';
    s.prop1 = `${merchantName} Pull:Discover Consent:Multiple Cards:Button:Link Now`;
    s.prop32 = 'View Port:' + detectView();
    s.prop41 = `${merchantName} Pull:Discover Consent:Link Now:Number of Cards=` + numofCardsSelect;
    s.tl(this, 'o', s.prop1);
    clearTags();
}

//Discover Consent (Multi Card) - Cancel Link..
export const OnMultiCardCancel = (merchant) => {
    const merchantName = capitalizeMerchantName(merchant)
    s.linkTrackVars = s.linkTrackVars + ',prop1,prop32';
    s.prop1 = `${merchantName} Pull:Discover Consent:Multiple Cards:Link:Cancel`;
    s.prop32 = 'View Port:' + detectView();
    s.tl(this, 'o', s.prop1);
    clearTags();
}

//Discover Consent (Multi Card) - Error..
export const OnMulticardLinkError = (errMsg, numofcards, merchant) => {
    const merchantName = capitalizeMerchantName(merchant)
    s.linkTrackVars = s.linkTrackVars+',prop1,prop32,prop10,list1,prop41';
    s.prop1=`${merchantName} Pull:Discover Consent:Multiple Cards:Button:Link Now`;
    s.prop10 = errMsg;
    s.list1='ERROR:'+errMsg;
    s.prop32 = 'View Port:' + detectView();
    s.prop41=`${merchantName} Pull:Discover Consent:Link Now:Number of Cards=`+numofcards;
    s.tl(this, 'o', s.prop1);
    clearTags();
}

//Success - On Redirect..
export const OnLinkingSuccess = (merchant) => {
    const merchantName = capitalizeMerchantName(merchant)
    s.pageName = `/${merchantName}Pull/Success`;
    s.prop32 = 'View Port:' + detectView();
    s.prop41 = `${merchantName} Pull:Success`;
    s.t();
    clearTags();
}

//Login - Tech Diff event..
export const OnLoginTechDiff = (merchant) => {
    const merchantName = capitalizeMerchantName(merchant)
    s.prop41 = `${merchantName} Pull:Login Page:Tech Diff`;
    s.pageName = `/${merchantName}Pull/Login/Tech Diff`;
    s.prop32 = 'View Port:' + detectView();
    s.t();
    clearTags();
}

//Login - Try Again Link..
export const OnLoginTryAgain = (merchant) => {
    const merchantName = capitalizeMerchantName(merchant)
    s.linkTrackVars = s.linkTrackVars + ',prop1,prop32';
    s.prop1 = `${merchantName} Pull:Login Page:Tech Diff:Link:Try Again`;
    s.prop32 = 'View Port:' + detectView();
    s.tl(this, 'o', s.prop1);
    clearTags();
}

//Login - Cancel Link..
export const OnLoginCancel = (techdiffFlag, merchant) => {
    const merchantName = capitalizeMerchantName(merchant)
    const techDiffMsg = (techdiffFlag) ? ':Tech Diff': '';
    // console.log("techDiffMsg",techDiffMsg)
    s.linkTrackVars = s.linkTrackVars + ',prop1,prop32';
    s.prop1 = `${merchantName} Pull:Login Page:Link:Cancel`;
    s.prop32 = 'View Port:' + detectView();
    s.tl(this, 'o', s.prop1);
    clearTags();
}

//OOB Intercept - Confirm - Page Load..
export const OnDisplayContactPageLoad = () => {
    s.pageName = '/OutOfBand-Step1-LoginOOB';
    s.prop41 = 'OOB:Step1:Landing Page';
    s.prop32 = 'View Port:' + detectView();
    s.t();
    clearTags();
}

//OOB Intercept - Confirm - Link: Change Contact Info Tooltip..
export const OnDisplayToolTip = () => {
    s.linkTrackVars = s.linkTrackVars + ',prop1,prop32';
    s.prop1 = 'OOB:Step1:Link:Change Contact Info Tooltip';
    s.prop32 = 'View Port:' + detectView();
    s.tl(this, 'o', 'OOB:Link:Landing Page');
    clearTags();
}

//OOB Intercept - Confirm - Link: Cancel..
export const OnDisplayContactCancel = () => {
    s.linkTrackVars = s.linkTrackVars + ',prop1,prop32';
    s.prop1 = 'OOB:Step1:Link:Cancel';
    s.prop32 = 'View Port:' + detectView();
    s.tl(this, 'o', 'OOB:Link:Landing Page');
    clearTags();
}


//OOB Intercept - Confirm - Button: Continue..
export const OnDisplayContactContinue = (submitcode) => {
    s.linkTrackVars = s.linkTrackVars + ',prop1,prop32,eVar4';
    s.prop1 = 'OOB:Step1:Button:Continue';
    s.eVar4 = 'OutOfBand:Get Code:' + submitcode;
    s.prop32 = 'View Port:' + detectView();
    s.tl(this, 'o', 'OOB:Link:Landing Page');
    clearTags();
}

//OOB Intercept - Enter Code - Page Load..
export const OnValidateCodePageLoad = () => {
    s.pageName = '/OutOfBand-EnterCode';
    s.prop41 = 'OOB:Step2:Landing Page';
    s.prop32 = 'View Port:' + detectView();
    s.t();
    clearTags();
}

//OOB Intercept - Enter Code - Link: Cancel..
export const OnValidateCodeCancel = () => {
    s.linkTrackVars = s.linkTrackVars + ',prop1,prop32';
    s.prop1 = 'OOB:Step2:Link:Cancel';
    s.prop32 = 'View Port:' + detectView();
    s.tl(this, 'o', 'OOB:Link:Landing Page');
    clearTags();
}

//OOB Intercept - Enter Code - Link: Get New Code..
export const OnValidateGetNewCode = () => {
    s.linkTrackVars = s.linkTrackVars + ',prop1,prop32';
    s.prop1 = 'OOB:Step2:Link:Get New Code';
    s.prop32 = 'View Port:' + detectView();
    s.tl(this, 'o', 'OOB:Link:Landing Page');
    clearTags();
}

//OOB Intercept - Enter Code - Button: Continue..
export const OnValidateCodeContinue = (submitcode) => {
    s.linkTrackVars = s.linkTrackVars + ',prop1,prop32';
    s.prop1 = 'OOB:Step2:Button:Continue';
    s.eVar4 = 'OutOfBand:Submit Code:' + submitcode;
    s.prop32 = 'View Port:' + detectView();
    s.tl(this, 'o', 'OOB:Link:Landing Page');
    clearTags();
}

//OOB Intercept - Enter Code - Error (Invalid Code)..
export const OnValidateInvalidCode = (msg) => {
    s.pageName = '/OutOfBand-ErrorState-InvalidCode';
    s.prop10 = 'OutofBand|' + msg;
    s.list1 = 'ERROR:' + msg;
    s.prop32 = 'View Port:' + detectView();
    s.eVar4 = 'OOB:Submit Code Error';
    s.prop41 = 'OOB:Error State:Landing Page';
    s.t();
    clearTags();
}

//OOB Intercept - Enter Code - Error (Invalid Code 2)..
export const OnValidCodeLastAttempt = (msg) => {
    s.pageName = '/OutOfBand-ErrorState-LastAttempt';
    s.prop10 = 'OutofBand|' + msg;
    s.list1 = 'ERROR:' + msg;
    s.prop32 = 'View Port:' + detectView();
    s.eVar4 = 'OOB:Submit Code Error';
    s.prop41 = 'OOB:Error State:Landing Page';
    s.t();
    clearTags();
}

//OOB Intercept - Enter Code - Error (Expired Code)..
export const OnValidCodeExpired = (msg) => {
    s.pageName = '/OutOfBand-ErrorState-ExpiredCode';
    s.prop10 = 'OutofBand|' + msg;
    s.list1 = 'ERROR:' + msg;
    s.prop32 = 'View Port:' + detectView();
    s.eVar4 = 'OOB:Submit Code Error';
    s.prop41 = 'OOB:Error State:Landing Page';
    s.t();
    clearTags();
}

//TOO MANY CODES REQUESTED / ERROR STATE - Error..
export const OnTooManyCodesRequested = () => {
    s.pageName = '/OutOfBand-Sorry-OutofCodeRequests';
    s.prop32 = 'View Port:' + detectView();
    s.eVar4 = 'OOB:Submit Code Error:Too Many Requests';
    s.prop41 = 'OOB:Error State:Landing Page';
    s.t();
    clearTags();
}

//TOO MANY CODES REQUESTED / ERROR STATE - Link: Cancel..
export const OnTooManyCodesReqCancel = () => {
    s.linkTrackVars = s.linkTrackVars + ',prop1,prop32';
    s.prop1 = 'OOB:Error State:Too Many Codes Requested:Link:Cancel';
    s.prop32 = 'View Port:' + detectView();
    s.tl(this, 'o', 'OOB:Link:Landing Page');
    clearTags();
}

//TOO MANY CODES SUBMITTED / ERROR STATE - Error..
export const OnTooManyCodesSubmitted = () => {
    s.pageName = '/OutOfBand-Sorry-OutofCodeSubmissions';
    s.prop32 = 'View Port:' + detectView();
    s.eVar4 = 'OOB:Submit Code Error:Too Many Code Submissions';
    s.prop41 = 'OOB:Error State:Landing Page';
    s.t();
    clearTags();
}

//TOO MANY CODES SUBMITTED / ERROR STATE - Link: Cancel..
export const OnTooManyCodesSubCancel = () => {
    s.linkTrackVars = s.linkTrackVars + ',prop1,prop32';
    s.prop1 = 'OOB:Error State:Too Many Code Submissions:Link:Cancel';
    s.prop32 = 'View Port:' + detectView();
    s.tl(this, 'o', 'OOB:Link:Landing Page');
    clearTags();
}

//OUT OF BAND // NO VALID CHANNELS / ERROR STATE -Error
export const OnNoContactChannelLoad = () => {
    s.pageName = '/OutOfBand-NoValidChannelPage';
    s.prop32 = 'View Port:' + detectView();
    s.eVar4 = 'OOB:Submit Code Error:No Valid Channels';
    s.prop41 = 'OOB:Error State:Landing Page';
    s.t();
    clearTags();
}

//OUT OF BAND // NO VALID CHANNELS / ERROR STATE - Cancel Link..
export const OnNoContactChannelCancel = () => {
    s.linkTrackVars = s.linkTrackVars + ',prop1,prop32';
    s.prop1 = 'OOB:Submit Code Error:No Valid Channels:Link:Cancel';
    s.prop32 = 'View Port:' + detectView();
    s.tl(this, 'o', 'OOB:Link:Landing Page');
    clearTags();
}

//CID Challenge Page - PageLoad..
export const OnCIDChallengePageLoad = () => {
    s.pageName = '/CID/Challenge';
    s.prop41 = 'CID:Challenge Page';
    s.prop32 = 'View Port:' + detectView();
    s.t();
    clearTags();
}

//CID Challenge Page - Cancel Link..
export const OnCIDCancel = () => {
    s.linkTrackVars = s.linkTrackVars + ',prop1,prop32';
    s.prop1 = 'CID:Challenge Page:Link:Cancel';
    s.prop32 = 'View Port:' + detectView();
    s.tl(this, 'o', s.prop1);
    clearTags();
}

//CID “You’ve tried to authenticate your account too many times” error page - PageLoad..
export const OnTriedAuthPageLoad = () => {

    s.pageName = '/CID/Error/TooManyTries';
    s.prop41 = 'CID:Error:Too Many Tries';
    s.prop32 = 'View Port:' + detectView();
    s.t();
    clearTags();
}

//CID “You’ve tried to authenticate your account too many times” error page - Cancel Link..
export const OnTryAuthCancel = () => {
    s.linkTrackVars = s.linkTrackVars + ',prop1,prop32';
    s.prop1 = 'CID:Error:Too Many Tries:Link:Cancel';
    s.prop32 = 'View Port:' + detectView();
    s.tl(this, 'o', s.prop1);
    clearTags();
}

//Locked Out Page - Page Load..
export const OnLockOutPageLoad = () => {
    s.pageName = '/LockedOut';
    s.prop41 = 'Locked Out Page';
    s.prop32 = 'View Port:' + detectView();
    s.t();
    clearTags();
}

//Locked Out Page - Cancel Link..
export const OnLockOutCancel = () => {
    s.linkTrackVars = s.linkTrackVars + ',prop1,prop32';
    s.prop1 = 'Locked Out Page:Link:Cancel';
    s.prop32 = 'View Port:' + detectView();
    s.tl(this, 'o', s.prop1);
    clearTags();
}

//Screen Refresh Error Page - Page Load..
export const OnRefreshPageLoad = (merchant) => {
    const merchantName = capitalizeMerchantName(merchant)
    s.pageName = `/${merchantName}Pull/RefreshError`;
    s.prop32 = 'View Port:' + detectView();
    s.prop41 = `${merchantName} Pull:Refresh Error`;
    s.t();
    clearTags();
}

//Screen Refresh Error Page - Cancel Link..
export const OnRefreshPageCancel = (merchant) => {
    const merchantName = capitalizeMerchantName(merchant)
    s.linkTrackVars = s.linkTrackVars + ',prop1,prop32';
    s.prop1 = `${merchantName} Pull:Refresh Error:Link:Cancel`;
    s.prop32 = 'View Port:' + detectView();
    s.tl(this, 'o', s.prop1);
    clearTags();
}

export const OnTryAgainPageLoad = (merchant) => {
    const merchantName = capitalizeMerchantName(merchant)
    s.pageName=`/${merchantName}Pull/TryAgain`;
    s.prop32="View Port:<Narrow|Middle|Wide>";
    s.prop41=`${merchantName} Pull:Try Again`;
    s.t();
    clearTags();
}

export const OnTryAgainPageCancel = (merchant) => {
    const merchantName = capitalizeMerchantName(merchant)
    s.linkTrackVars=s.linkTrackVars+',prop1,prop32'; 
    s.prop1=`${merchantName} Pull:Try Again:Link:Cancel`;
    s.prop32='View Port:<Narrow|Middle|Wide>';
    s.tl(this,'o',s.prop1);
    clearTags(); 
}
export const OnRADenyPageLoad = (merchant) => {
    console.log("inside deny tag")
    const merchantName = capitalizeMerchantName(merchant)
    s.pageName=`/${merchantName}Pull/RADeny`;
    s.prop32='View Port:<Narrow|Middle|Wide>';
    s.prop41=`${merchantName} Pull:RADeny`;
    s.t();
    clearTags();
}

export const OnRADenyPageCancel = (merchant) => {
    const merchantName = capitalizeMerchantName(merchant)
    s.linkTrackVars=s.linkTrackVars+',prop1,prop32'; 
    s.prop1=`${merchantName} Pull:RADeny:Link:Cancel`;
    s.prop32='View Port:<Narrow|Middle|Wide>';
    s.tl(this,'o',s.prop1);
    clearTags();
}

//clear tags..
export const clearTags = () => {
    s.prop1 = '';
    s.prop41 = '';
    s.eVar4 = '';
    s.prop10 = '';
    s.list1 = '';
    s.prop5 = '';
}